import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersListComponent } from './components/users-list/users-list.component';
import { UsersRoutingModule } from './users.routes';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { QuestionnaireAddEditComponent } from './components/questionnaire-add-edit/questionnaire-add-edit.component';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { UsersUploadComponent } from 'libs/users/src/lib/containers/users-upload/users-upload.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { GenderPipe } from '@beautyapp/core';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';

@NgModule({
    imports: [
    CommonModule,
    UsersRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    NzModalModule,
    NzGridModule,
    NzTableModule,
    NzButtonModule,
    NzIconModule,
    NzFormModule,
    NzInputModule,
    NzAffixModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzDrawerModule,
    NzTabsModule,
    NzCardModule,
    NzTypographyModule,
    NzListModule,
    NzAvatarModule,
    NzBadgeModule,
    NzTagModule,
    NzPopoverModule,
    NzSpaceModule,
    NzPageHeaderModule,
    NzResultModule,
    NgxPermissionsModule.forChild(),
    NzAlertModule,
    NzDividerModule,
    NzCheckboxModule,
    NzDatePickerModule,
    TranslatePipe,
    GenderPipe,
    UsersListComponent,
    QuestionnaireAddEditComponent,
    UsersUploadComponent
],
    exports: [
        UsersListComponent,
        QuestionnaireAddEditComponent,
        UsersUploadComponent
    ]
})
export class UsersModule {
}
